var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(
            _vm.markets &&
            _vm.markets.length > 0 &&
            _vm.markets[0].outcomes &&
            _vm.markets[0].outcomes.length > 0
        )?_c('div',[_vm._l((_vm.markets[0].outcomes),function(runner,index){return [_c('v-card',{key:`key-${index}`,staticClass:"d-flex align-center item-odds",attrs:{"dense":"","light":"","flat":"","tile":"","height":"45"}},[(!_vm.twoOdds)?_c('v-btn',_vm._g(_vm._b({staticClass:"text-capitalize text-left justify-start caption font-weight-bold flex-grow-1 flex-shrink-1 pl-2",attrs:{"text":"","tile":"","color":"white"}},'v-btn',_vm.$attrs,false),_vm.$listeners),[_c('span',{staticClass:"black--text manage-overflow-two"},[_vm._v("\n                        "+_vm._s(runner.name)+"\n                        "),(_vm.$auth.loggedIn)?_c('span',[_c('br'),_vm._v(" "),(
                                    _vm.books &&
                                    _vm.books[_vm.markets[0]._id] &&
                                    _vm.books[_vm.markets[0]._id].length &&
                                    _vm.books[_vm.markets[0]._id][0].book
                                )?_c('span',{class:{
                                    'green--text ':
                                        _vm.books[_vm.markets[0]._id][0].book[
                                            runner.id
                                        ] > 0,
                                    'red--text':
                                        _vm.books[_vm.markets[0]._id][0].book[
                                            runner.id
                                        ] < 0,
                                    'black--text ':
                                        _vm.books[_vm.markets[0]._id][0].book[
                                            runner.id
                                        ] == 0
                                }},[_vm._v("\n                                "+_vm._s(_vm.books[_vm.markets[0]._id][0].book[runner.id])+"\n                            ")]):_vm._e(),_vm._v(" "),(
                                    _vm.newBooksPremium &&
                                    _vm.newBooksPremium[_vm.markets[0]._id] &&
                                    _vm.newBooksPremium[_vm.markets[0]._id]
                                        .length &&
                                    _vm.newBooksPremium[_vm.markets[0]._id][0]
                                        .book &&
                                    _vm.newBooksPremium[_vm.markets[0]._id][0].book
                                        .length
                                )?_c('span',{class:{
                                    'green--text ':
                                        _vm.getBooks(
                                            _vm.books[_vm.markets[0]._id],
                                            runner.id
                                        ) +
                                            _vm.getBooks(
                                                _vm.newBooksPremium[
                                                    _vm.markets[0]._id
                                                ],
                                                runner.id
                                            ) >
                                        0,
                                    'red--text':
                                        _vm.getBooks(
                                            _vm.books[_vm.markets[0]._id],
                                            runner.id
                                        ) +
                                            _vm.getBooks(
                                                _vm.newBooksPremium[
                                                    _vm.markets[0]._id
                                                ],
                                                runner.id
                                            ) <
                                        0,
                                    'black--text ':
                                        _vm.getBooks(
                                            _vm.books[_vm.markets[0]._id],
                                            runner.id
                                        ) +
                                            _vm.getBooks(
                                                _vm.newBooksPremium[
                                                    _vm.markets[0]._id
                                                ],
                                                runner.id
                                            ) ==
                                        0
                                }},[(
                                        _vm.books &&
                                        _vm.books[_vm.markets[0]._id] &&
                                        _vm.books[_vm.markets[0]._id].length &&
                                        _vm.books[_vm.markets[0]._id][0].book &&
                                        _vm.getBooks(
                                            _vm.newBooksPremium[_vm.markets[0]._id],
                                            runner.id
                                        )
                                    )?_c('v-icon',{attrs:{"size":"12"}},[_vm._v("mdi-chevron-right\n                                ")]):_vm._e(),_vm._v(" "),_vm._v("\n                                "+_vm._s(_vm._f("currencyFormat")((_vm.getBooks(
                                        _vm.books[_vm.markets[0]._id],
                                        runner.id
                                    ) /
                                        _vm.getMyRate() +
                                        _vm.getBooks(
                                            _vm.newBooksPremium[_vm.markets[0]._id],
                                            runner.id
                                        )),2))+"\n                            ")],1):_vm._e()]):_vm._e()])]):_vm._e(),_vm._v(" "),(_vm.checkIfSuspended(_vm.markets[0]))?_c('odds-disabled',_vm._g(_vm._b({attrs:{"text":_vm.checkIfSuspended(_vm.markets[0])}},'odds-disabled',_vm.$attrs,false),_vm.$listeners)):_vm._e(),_vm._v(" "),_vm._l((_vm.xsOnlyOdds(
                        _vm.$breakpoint.xsOnly,
                        'back'
                    )),function(i,key){return [(
                            ((i === 0 && _vm.twoOdds) || !_vm.twoOdds) &&
                            (!_vm.$auth.user ||
                                !(
                                    _vm.$auth.user &&
                                    !_vm.$auth.user.matchOdds &&
                                    _vm.market &&
                                    _vm.market.markets &&
                                    _vm.market.markets.length > 0 &&
                                    _vm.market.markets[0].name.toLowerCase() ===
                                        'winner (incl. super over)'
                                ))
                        )?_c('btn-odds',{key:'back' + key,class:{
                            'opacity-0': i !== 0 && _vm.twoOdds,
                            'flex-grow-1': _vm.twoOdds
                        },attrs:{"type":"back","disabled":(i !== 0 && _vm.twoOdds) ||
                            !_vm.check(
                                _vm.markets[0].outcomes,
                                index,
                                !_vm.$breakpoint.xsOnly && key !== 2
                            )},on:{"betData":function($event){return _vm.$store.commit('placeBet/openPopover', {
                                market: _vm.markets[0],
                                runner,
                                allRunners: _vm.markets[0].outcomes,
                                oddsIndex: i,
                                odds: runner.odds,
                                type: 'back',
                                bettingType: 'premiumsports'
                            })}}},[(
                                !_vm.check(
                                    _vm.markets[0].outcomes,
                                    index,
                                    !_vm.$breakpoint.xsOnly && key !== 2
                                )
                            )?_c('span',{staticClass:"d-block text-center",staticStyle:{"font-weight":"800 !important"}},[_vm._v("\n                            -\n                        ")]):_c('span',{staticClass:"d-block text-center"},[_c('span',{staticClass:"position-relative"},[_vm._v("\n                                "+_vm._s(runner.odds)+"\n                            ")])])]):_vm._e()]}),_vm._v(" "),_vm._l((_vm.xsOnlyOdds(_vm.$breakpoint.xsOnly)),function(i,key){return [(
                            ((i === 0 && _vm.twoOdds) || !_vm.twoOdds) &&
                            (!_vm.$auth.user ||
                                !(
                                    _vm.$auth.user &&
                                    !_vm.$auth.user.matchOdds &&
                                    _vm.market &&
                                    _vm.market.markets &&
                                    _vm.market.markets.length > 0 &&
                                    _vm.market.markets[0].name.toLowerCase() ===
                                        'winner (incl. super over)'
                                ))
                        )?_c('btn-odds',{key:'lay' + key,class:{
                            'opacity-0': i !== 0 && _vm.twoOdds,
                            'flex-grow-1': _vm.twoOdds
                        },attrs:{"type":"lay","disabled":true}},[_c('span',{staticClass:"d-block text-center"},[_vm._v("-")])]):_vm._e()]})],2),_vm._v(" "),(
                    _vm.$breakpoint.smAndDown &&
                    _vm.nonBetFairBetSlipOpener(
                        _vm.$auth,
                        _vm.$store,
                        runner.id,
                        _vm.markets[0]._id
                    )
                )?_c('bet-popover',{key:`p-${index}`,attrs:{"radius-class":_vm.markets[0].outcomes.length > 1 &&
                    index !== _vm.markets[0].outcomes.length - 1
                        ? 'no-radius'
                        : index === _vm.markets[0].outcomes.length - 1
                        ? 'top-radius'
                        : 'all-radius',"check-id":runner.id}}):_vm._e()]})],2):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }